import { useCallback } from 'react';
import { useGetDisplayWebContentSelector } from './useGetDisplayWebContentSelector';

export const useNameSelector = () => {
  const getDisplayWebContent = useGetDisplayWebContentSelector();

  return useCallback((id: string) => getDisplayWebContent(id)?.name, [getDisplayWebContent]);
};
